// errorComposer will compose a handleGlobally function
const errorComposer = error => {
    return () => {
        const statusCode = error.response ? error.response.status : null

        if (statusCode === 402) {
            window.bus.$emit('credit_unavailable')
        }
    }
}

export default errorComposer
